var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPro14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_10_53",
    "data-name": "Komponente 10 \\u2013 53",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.436,
    height: 67.997,
    viewBox: "0 0 60.436 67.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "take-away",
    transform: "translate(-4 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46765",
    "data-name": "Pfad 46765",
    d: "M49.313,9.65V.906A.906.906,0,0,0,47.949.124L43.757,2.576,39.567.124a.908.908,0,0,0-.915,0L34.464,2.575,30.28.124a.91.91,0,0,0-.916,0L25.178,2.575,20.993.124a.908.908,0,0,0-.915,0L15.893,2.575,11.708.124a.907.907,0,0,0-1.364.782v8.7A25.5,25.5,0,0,0,4,26.281V53.469A4.536,4.536,0,0,0,8.531,58H50.219a4.536,4.536,0,0,0,4.531-4.531V26.281A27.714,27.714,0,0,0,49.313,9.65ZM15.435,4.407a.908.908,0,0,0,.915,0l4.185-2.451,4.185,2.451a.908.908,0,0,0,.915,0l4.186-2.451,4.183,2.451a.91.91,0,0,0,.916,0l4.188-2.451L43.3,4.407a.908.908,0,0,0,.915,0L47.5,2.486V9.062H12.156V2.487ZM41.156,26.281V56.188H8.531a2.722,2.722,0,0,1-2.719-2.719V26.281a24.107,24.107,0,0,1,5.834-15.406h34.8A25.607,25.607,0,0,0,41.156,26.281ZM52.938,53.469a2.722,2.722,0,0,1-2.719,2.719h-7.25V26.281A24.084,24.084,0,0,1,48.35,11.409a26.574,26.574,0,0,1,4.587,14.873Z",
    transform: "translate(0 0)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46766",
    "data-name": "Pfad 46766",
    d: "M32.236,44.677l-5.411-5.411a.906.906,0,1,0-1.281,1.281l5.411,5.411A2.718,2.718,0,1,0,34.8,42.114l-2.789-2.789a.906.906,0,0,0-1.281,1.281l2.789,2.79a.9.9,0,0,1,0,1.281.905.905,0,0,1-1.281,0Z",
    transform: "translate(-1.995 -3.656)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46767",
    "data-name": "Pfad 46767",
    d: "M15.934,35.3a.92.92,0,0,0,.255.036.906.906,0,0,0,.255-1.776,8.842,8.842,0,0,1-3.737-2.268A8.506,8.506,0,0,1,10.2,26.423a4.809,4.809,0,0,1,1.224-4.107c1.773-1.773,4.916-1.7,7.639.17a.907.907,0,1,0,1.027-1.494c-3.455-2.376-7.545-2.36-9.947.042-2.827,2.827-2.251,8,1.282,11.535a10.666,10.666,0,0,0,4.51,2.727Z",
    transform: "translate(-0.408 -1.802)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46768",
    "data-name": "Pfad 46768",
    d: "M36.007,25.77,30.88,30.9a.9.9,0,0,1-1.281,0l5.768-5.767a2.719,2.719,0,0,0-3.845-3.846l-5.767,5.767a.907.907,0,0,1,0-1.281l5.127-5.127a2.721,2.721,0,0,0,0-3.844,2.784,2.784,0,0,0-3.844,0l-5.127,5.126a6.348,6.348,0,0,0,0,8.971L12.3,40.507a2.719,2.719,0,1,0,3.844,3.845l9.613-9.612a6.351,6.351,0,0,0,8.971,0l5.126-5.127a2.718,2.718,0,0,0-3.844-3.844Zm2.563,2.563L33.444,33.46a4.537,4.537,0,0,1-6.408,0l-.641-.641a.905.905,0,0,0-1.281,0L14.86,43.071a.926.926,0,0,1-1.281,0,.906.906,0,0,1,0-1.281L23.832,31.537a.905.905,0,0,0,0-1.281l-.641-.641a4.537,4.537,0,0,1,0-6.408l5.128-5.126a.9.9,0,0,1,1.281,0,.907.907,0,0,1,0,1.281l-5.127,5.127a2.722,2.722,0,0,0,0,3.845l.642.641a.908.908,0,0,0,1.281,0L32.8,22.568a.906.906,0,1,1,1.281,1.282l-6.408,6.407a.905.905,0,0,0,0,1.281l.642.642a2.721,2.721,0,0,0,3.844,0l5.127-5.127a.906.906,0,1,1,1.281,1.281Z",
    transform: "translate(-0.703 -1.503)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46769",
    "data-name": "Pfad 46769",
    d: "M52,22.906V53.719a.906.906,0,1,0,1.813,0V22.906a.906.906,0,1,0-1.813,0Z",
    transform: "translate(-4.5 -2.062)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46770",
    "data-name": "Pfad 46770",
    d: "M37.188,51H10.906a.905.905,0,0,0-.906.906v5.438a.905.905,0,0,0,.906.906H37.188a.905.905,0,0,0,.906-.906V51.906A.905.905,0,0,0,37.188,51Zm-.906,5.438H11.813V52.813H36.281Z",
    transform: "translate(-0.562 -4.781)",
    fill: "#2ecf96"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35466",
    "data-name": "Gruppe 35466",
    transform: "translate(-333.564 -2893.002)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(364 2931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    transform: "translate(367 2934)",
    fill: "#fff",
    stroke: "#2ecf96",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46717",
    "data-name": "Pfad 46717",
    d: "M23.5,6l-7.692,7.7L13.5,11.392",
    transform: "translate(360.5 2936.15)",
    fill: "none",
    stroke: "#2ecf96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro14);
export default __webpack_public_path__ + "static/media/Pro14.0323a185e65f5fdcd226e2e12bfdb387.svg";
export { ForwardRef as ReactComponent };